import { Routes } from '@angular/router';
import { riskManagerGuard } from '@core/guards/risk-manager.guard';

export const countrySectorAdviceRoutes: Routes = [
  {
    path: 'country-sector-advice',
    loadComponent: () => import('./country-sector-advice/country-sector-advice.component').then(m => m.CountrySectorAdviceComponent),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'country-sector-advice/new',
    loadComponent: () =>
      import('./country-sector-advice/new-country-sector-advice/new-country-sector-advice.component').then(
        m => m.NewCountrySectorAdviceComponent
      ),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'country-sector',
    loadComponent: () => import('./country-sector.component').then(m => m.CountrySectorComponent),
    canActivate: [riskManagerGuard],
  },
];
